import { NextApiResponse } from 'next';
import { getRoutePure, RoutesType } from 'constants/routes';
import { ToastInterface } from 'components/layouts/Toast';

export const serverRedirect = (
    route: RoutesType,
    res: NextApiResponse,
    message?: ToastInterface,
    redirect: string = null
): void => {
    const init: any = {};
    if (typeof message !== 'undefined') {
        init.message = message.message;
        init.message_title = message.messageTitle;
        init.message_type = message.messageType;
    }

    if (redirect !== null) {
        try {
            if (redirect.includes('?')) {
                const [path, queryString] = redirect.split('?');
                const params = new URLSearchParams(queryString);

                params.delete('discipline');

                if ([...params.keys()].length > 0) {
                    redirect = `${path}?${params.toString()}`;
                } else {
                    redirect = path;
                }
            }
        } catch (error) {
            console.error(
                'Chyba při zpracování parametrů pro redirect:',
                error
            );
        }

        init.redirect = redirect;
    }

    const params = new URLSearchParams(init);

    res.writeHead(302, {
        Location:
            getRoutePure(route) +
            (params.toString() ? '?' + params.toString() : ''),
    });
    res.end();
};
